import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ControlledCountryPicker } from '#components/form/FormCountryPicker.tsx';
import { ControlledFormInput } from '#components/form/FormInput.tsx';

type LocationAutocompleteProps = {
    addressPrefix?: string;
    disabled?: boolean;
};

const AddressForm = ({ addressPrefix, disabled }: LocationAutocompleteProps) => {
    const intl = useIntl();
    const { control } = useFormContext();
    const locationPrefix = addressPrefix ? `${addressPrefix}.location` : 'location';

    return (
        <div className='display-flex flex-column column-gap-10 row-gap-5'>
            <div className='display-flex gap-10'>
                <div className='width-80pct'>
                    <ControlledFormInput
                        label={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.form-input.street',
                        })}
                        control={control}
                        name={`${locationPrefix}.street`}
                        formGroupClassName={'margin-bottom-0'}
                        disabled={disabled}
                    />
                </div>
                <div className='width-20pct'>
                    <ControlledCountryPicker
                        label={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.form-input.country',
                        })}
                        control={control}
                        name={`${locationPrefix}.country`}
                        formGroupClassName={'margin-bottom-0'}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className='display-flex gap-10'>
                <div className='width-25pct'>
                    <ControlledFormInput
                        label={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.form-input.zip-code',
                        })}
                        name={`${locationPrefix}.zipCode`}
                        control={control}
                        disabled={disabled}
                    />
                </div>
                <div className='width-75pct'>
                    <ControlledFormInput
                        label={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.address-autocomplete.form-input.city',
                        })}
                        name={`${locationPrefix}.city`}
                        control={control}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddressForm;
